<template>
    <div>

    </div>
</template>
<script>
import { inject, onMounted } from 'vue';

export default {
    setup: function () {
        const modalStore = inject("ModalStore")
        const modalController = modalStore.methods.getModalController()

        onMounted(() => {
            modalController.claimAlertModal.clearModal()
                .setTitle("กรุณาเข้าสู่ระบบ")
                .setMsg("คุณเป็นสมาชิกของ Thanachart Insurance อยู่แล้ว กรุณากดที่เมนู แจ้งเคลมผ่านไลน์ เพื่อทำการแจ้งเคลม")
                .show({
                    btnComponent: 'line'
                })
        })
    }
}
</script>